/**
* @file Input component for boolean input
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { InputBase } from '../input-base/input-base';
/**
 * Class for input component for boolean input
 */
var InputBooleanComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputBooleanComponent, _super);
    function InputBooleanComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Toggle between boolean value (true or false)
     */
    InputBooleanComponent.prototype.toggle = function () {
        this.setValue(!this.value);
    };
    /**
     * Set value is true
     */
    InputBooleanComponent.prototype.setTrue = function () {
        this.setValue(true);
    };
    /**
     * Set value is false
     */
    InputBooleanComponent.prototype.setFalse = function () {
        this.setValue(false);
    };
    return InputBooleanComponent;
}(InputBase));
export { InputBooleanComponent };
